module.exports = __webpack_public_path__ + "img/pile3.f789275e.png";